<template>
    <div class="promotion-allocation-area__data" :class="colourClass">
        <promotion-rag-colour :colour="params.data.effectivenessRating" />
    </div>
</template>

<script>
import promotionCellRendererMixin from './promotion-cell-renderer-mixin';

export default {
    name: 'PromotionRagColourRenderer',
    mixins: [promotionCellRendererMixin],
};
</script>
